var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectReferralsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "User-Multiple-Group--Streamline-Core",
    xmlns: "http://www.w3.org/2000/svg",
    width: "6.33mm",
    height: "4.59mm",
    viewBox: "0 0 17.94 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "cls-1",
    d: "M5,5.5c1.38,0,2.5-1.12,2.5-2.5S6.38.5,5,.5s-2.5,1.12-2.5,2.5,1.12,2.5,2.5,2.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    "data-name": "Vector 2",
    className: "cls-1",
    d: "M.5,12.5h9v-.54c0-.76-.21-1.51-.58-2.17-.38-.66-.91-1.22-1.56-1.62-.65-.4-1.39-.63-2.15-.66-.07,0-.14,0-.2,0-.07,0-.14,0-.2,0-.76.04-1.5.26-2.15.66-.65.4-1.19.96-1.56,1.62-.38.66-.58,1.41-.58,2.17v.54Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    "data-name": "Vector 3",
    className: "cls-1",
    d: "M9,5.5c1.38,0,2.5-1.12,2.5-2.5s-1.12-2.5-2.5-2.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    "data-name": "Vector 4",
    className: "cls-1",
    d: "M11.5,12.44h2v-.54c0-.76-.21-1.51-.58-2.17-.38-.66-.91-1.22-1.56-1.62-.42-.26-.88-.45-1.35-.55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3-2",
    "data-name": "Vector 3",
    className: "cls-1",
    d: "M12.67,5.5c1.38,0,2.5-1.12,2.5-2.5s-1.12-2.5-2.5-2.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4-2",
    "data-name": "Vector 4",
    className: "cls-1",
    d: "M15.44,12.44h2v-.54c0-.76-.21-1.51-.58-2.17-.38-.66-.91-1.22-1.56-1.62-.42-.26-.88-.45-1.35-.55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectReferralsIcon);
export default __webpack_public_path__ + "static/media/direct-referrals-icon.239eceb146dde1b4002d4f4a0a1f0acd.svg";
export { ForwardRef as ReactComponent };